var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#FF9500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1716_737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 27.51C31.5 27.978 31.327 28.3349 30.9811 28.5809C30.6352 28.827 30.2107 28.95 29.7075 28.95H12.2925C11.7893 28.95 11.3648 28.8239 11.0189 28.572C10.673 28.32 10.5 27.966 10.5 27.51C10.5 27.15 10.6132 26.784 10.8396 26.412L19.5377 11.94C19.9528 11.28 20.4434 10.95 21.0094 10.95C21.5755 10.95 22.0535 11.28 22.4434 11.94L31.1604 26.43C31.3868 26.814 31.5 27.174 31.5 27.51ZM22.3113 18.312V15.684H19.6887V18.312C19.6887 18.48 19.7013 18.639 19.7264 18.789C19.7516 18.939 19.7862 19.107 19.8302 19.293C19.8742 19.479 19.9088 19.638 19.934 19.77L20.4245 22.686H21.5377L22.0472 19.77C22.0723 19.65 22.1101 19.494 22.1604 19.302C22.2107 19.11 22.2484 18.939 22.2736 18.789C22.2987 18.639 22.3113 18.48 22.3113 18.312ZM22.3113 25.278C22.3113 24.93 22.1824 24.636 21.9245 24.396C21.6667 24.156 21.3553 24.036 20.9906 24.036C20.6384 24.036 20.3333 24.156 20.0755 24.396C19.8176 24.636 19.6887 24.93 19.6887 25.278C19.6887 25.626 19.8176 25.923 20.0755 26.169C20.3333 26.415 20.6384 26.538 20.9906 26.538C21.3553 26.538 21.6667 26.415 21.9245 26.169C22.1824 25.923 22.3113 25.626 22.3113 25.278Z",
    fill: "#FF9500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1716_737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 18,
    fill: "white",
    transform: "translate(10.5 10.95)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.5e6553bf610a6b113703f715832e2b44.svg";
export { ForwardRef as ReactComponent };